import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { CONTRACTS_AND_ASSETS, INVOICES, SUMMARY } from '../../constants/messages.tsx';
import GeneralSearchBar from '../Header/GeneralSearchBar/GeneralSearchBar';
import Box from '@mui/material/Box';
import { useUserAccountRole } from '../../hooks/useUserAccountRole';

const MobileNavMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { role } = useUserAccountRole();

  const navLinks = [
    { label: SUMMARY, path: '/' },
    { label: CONTRACTS_AND_ASSETS, path: '/contracts' },
    ...(role?.restrictInvoices ? [] : [{ label: INVOICES, path: '/invoices' }]),
    // Add more links as needed
  ];

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open navigation menu"
        onClick={handleMenuOpen}
        edge="start"
        sx={{ mr: 2 }}
        data-testid="mobile-menu-button"
      >
        <MenuIcon fontSize="large" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { minWidth: 300, maxWidth: 400, px: 2, pt: 2 } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
          <GeneralSearchBar />
        </Box>
        {navLinks.map((link) => (
          <MenuItem
            key={link.label}
            component={Link}
            to={link.path}
            onClick={handleMenuClose}
            data-testid={`mobile-nav-link-${link.label.replace(/\s+/g, '-').toLowerCase()}`}
          >
            {link.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileNavMenu;
